<template>
  <div class="news content">
    <div class="banner-sub">
      <img :src="topBg.bannerImg" alt="">
    </div>
    <div class="wrap">
      <div class="left">
        <div class="part-details">
          <div class="part-title"><h2>{{label}}</h2></div>
        </div>
        <div class="part2" v-if="newsList && newsList.length > 0">
          <!-- 单条新闻  开始 -->
          <div class="item" v-for="(news, index) in newsList" :key="index" @click="toNewsInfo(news.id)">
            <div class="imgItem"><img :src="news.img" alt=""></div>
            <div class="news-detail">
              <h5 class="news-01">{{news.title}}</h5>
              <div class="news-02">
                <p v-html="news.summary"></p>
              </div>
              <div class="news-03">
                <span>{{news.author}}</span>
                <span>{{news.publicTime}}</span>
              </div>
              <div class="news-04" v-if="news.label">
                <span v-for="(label, index) in news.label.split(',')" :key="index">{{label}}</span>
              </div>
            </div>
          </div>
          <!-- 单条新闻  结束 -->
          <div class="page">
            <pagination :pagination="pagination" :callback="getTableData" :options="paginationOptions"></pagination>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="part-r1 rp">
          <h2 class="title">标签</h2>
          <div class="item-r1" v-if="labelList && labelList.length > 0">
            <template>
              <span
                v-for="(item, index) in labelList"
                :style="{color: (label === item.label ? '#0d70b8':'#000') }"
                :key="index"
                @click="labelHandler(item.label)">{{item.label}}</span>
            </template>
          </div>
        </div>
        <div class="part-r2 rp">
          <h2 class="title">点击排行</h2>
          <template v-if="topNewsList && topNewsList.length > 0">
            <template>
              <div class="item-r2" v-for="(topNews, index) in topNewsList" :key="index" @click="toNewsInfo(topNews.id)">
                <div class="news-item-img" ><img :src="topNews.img" alt=""></div>
                <p>{{topNews.title}}</p>
              </div>
            </template>
          </template>
        </div>
        <div class="part-r3">
          <div>
            <img src="../assets/img/news1.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'vue-bootstrap-pagination'
import {ApiWebArticleHotLabel, ApiWebArticleNews, ApiWebArticleTopRead, ApiWebArticleBg} from '../api/news'
export default {
  name: 'news',
  data () {
    return {
      pagination: {
        per_page: 10, // 每页数
        current_page: 1, // 当前页
        last_page: 35 // 总页数
      },
      paginationOptions: {
        offset: 4,
        previousText: '<',
        nextText: '>',
        alwaysShowPrevNext: true
      },
      // 当前标签
      label: '',
      // 新闻列表
      newsList: [],
      // 标签列表
      labelList: [],
      // 前6新闻列表
      topNewsList: [],
      topBg: {}
    }
  },
  components: {
    pagination
  },
  mounted () {
    this.label = this.$route.params.label
    this.initNewsTable()
    this.initLabel()
    this.topReadNews()
    this.topbackground()
  },
  methods: {
    /**
     * 分页回调函数
     */
    getTableData () {
      this.initNewsTable()
    },
    /**
     * 初始化新闻列表
     */
    initNewsTable () {
      let params = {
        page: {
          curr: this.pagination.current_page,
          size: this.pagination.per_page
        },
        form: {
          label: this.label
        }
      }
      ApiWebArticleNews(params).then(({data}) => {
        if (data && data.status === 0) {
          let table = data.data
          this.newsList = table.list
          this.pagination.current_page = table.curr
          this.pagination.per_page = table.size
          this.pagination.last_page = table.page
        }
      })
    },
    /**
     * 初始化标签
     */
    initLabel () {
      ApiWebArticleHotLabel().then(({data}) => {
        if (data && data.status === 0) {
          this.labelList = data.data
        }
      })
    },
    /**
     * top6新闻列表
     */
    topReadNews () {
      ApiWebArticleTopRead().then(({data}) => {
        if (data && data.status === 0) {
          this.topNewsList = data.data
        }
      })
    },
    /**
     * 新闻详情
     * @param id 新闻id
     */
    toNewsInfo (id) {
      this.$router.push({ name: 'newsDetail', params: { newsId: id } })
    },
    /**
     * 标签点击事件
     * @param label 标签名称
     */
    labelHandler (label) {
      this.label = label
      this.initNewsTable()
    },
    /**
     * 新闻动态顶部背景图
     */
    topbackground () {
      ApiWebArticleBg().then(({data}) => {
        if (data && data.status === 0) {
          this.topBg = data.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
</style>



// WEBPACK FOOTER //
// src/components/news-tips.vue